import styled from "styled-components";
import breakpoint from "../../assets/breakpoints";
import { Container } from "../../components/common/Container";
export const ChatContainer = styled(Container)`
  @media only screen and ${breakpoint.device.sm} {
    margin: 0;
  }
`;
